var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"rounded-lg _safeAreaInsetContentMargin _box-shadow",staticStyle:{"hyphens":"auto","overflow-y":"auto"},attrs:{"id":"sheet","rounded":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }